import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';
import { formatHref } from '@/utils/formatHref';
import { Grid, SxProps } from '@mui/material';

interface DpOfferChipGridProps {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpOfferChipGrid: React.FC<DpOfferChipGridProps> = ({ children, sx }) => (
	<Grid
		sx={combineSX([
			{
				display: 'flex',
				flexDirection: 'row',
				overflow: 'auto',
			},
			sx,
		])}
	>
		{children}
	</Grid>
);

interface DpOfferChipProps {
	sx?: SxProps;
	href?: string;
	children: React.ReactNode;
}

export const DpOfferChip: React.FC<DpOfferChipProps> = ({ sx, children, href }) => {
	const _href = href ? formatHref(href) : undefined;

	return (
		<Linkable
			type="chip"
			color="primary"
			sx={combineSX([
				{
					color: 'white',
					fontWeight: 'bold',
					mr: 1,
					borderRadius: '22px',
					height: '44px',
					fontSize: '15px',
					marginBottom: { xs: '17px', md: '0px' },
					width: 'fit-content',
					textTransform: 'capitalize',
					cursor: href ? 'pointer' : 'default',
				},
				sx,
			])}
			size="medium"
			label={children}
			component={href ? 'a' : 'div'}
			href={_href}
		/>
	);
};
